import React, { useRef, memo,useEffect,useState } from 'react'
import Barcode from 'react-barcode'
import { BASE_URL2 } from 'config/axios'
import { GrupoLogo } from 'assets/icons'
import LabelCard from '../LabelCard'
import MultiFabricLabels from '../MultiFabricLabels'
import { FrLogo, ZaraQr } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'

const Page2Book = ({ data,sizeData, selectColor = 0, barcodeValue  }) => {
  const { cards, lastNumber } = MultiFabricLabels({ data: data })
  let currentNumber = lastNumber
  const { referance } = useOrderStore()
  const ref = useRef(null)
  const isBlackLabel = referance?.backgroundColor === 'B'
  const [isSymbolTranslate, setIsSymbolTranslate] = useState(!!data.symbolTranslate)
  const symbol = data?.washingLabel[0]?.symbol

  const additionalPhrases = data.additionalPhrases || []
  const washingAdditionalPhrases = data.washingAdditionalPhrases || []

  const [isEmptyLabel, setIsEmptyLabel] = useState(false);
  const [orderedLabels, setOrderedLabels] = useState([]);

  const isBlack = referance?.backgroundColor === 'B'

  const barcodeRef = useRef(null);
  useEffect(() => {
    // Barcode render edildikten sonra SVG'yi bulmak için kısa bir gecikme
    const timer = setTimeout(() => {
      if (barcodeRef.current) {
        const svgElement = barcodeRef.current.querySelector('svg');
        if (svgElement) {
          const textElement = svgElement.querySelector('text');
          if (textElement) {
            textElement.style.fill = isBlack ? 'white' : ''; // isBlack true ise siyah, değilse kırmızı yap
          }
        }
      }
    }, 100); // 100ms gecikme - barcode render edilsin

    return () => clearTimeout(timer);
  }, [barcodeValue, isBlack]);

  // Tüm label'ları topla ve number'a göre sırala
  useEffect(() => {
    const allLabels = [];
    let tempCurrentNumber = lastNumber;

    // Label 1 - Barcode
    allLabels.push({
      number: 1,
      type: 'front',
      jsx: (
      
           <LabelCard key="label-1" type="front" number={1}>
        <div className="pl-[4.4mm] pr-[7.5mm] pt-[4mm]">
              {isBlack && (
        <div style={{ backgroundColor: "white", height: 19, width: 156, position: "absolute", top: 16 }}></div>
      )}
          <div className="flex">
            {isBlack && <div  className="h-[19px] w-3  mt-[1px]" />}
            <div ref={barcodeRef} className="inline-flex flex-col tracking-[.10rem]">
              <Barcode
                value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                format="ITF14"
                width={1}
                height={19}
                marginLeft={1}
                marginRight={1}
                marginTop={1}
                marginBottom={1}
                background="transparent"
                lineColor={isBlack ? '#000000' : '#000000'}
                fontSize={9}
                font="Arial"
              />
            </div>
            {isBlack && <div className="h-[19px] w-3  mt-[1px]" />}
          </div>
          <div className="mt-1">
            <div className="flex w-full justify-between">
              <p style={{ color: isBlack ? '#FFFFFF' : '#000000',fontFamily:'PdfSafe' }} className="pdf-force text-[6pt] font-normal">{`${data?.articleNo || 'N/A'}/${data?.washingLabel?.[selectColor]?.colorCode || 'N/A'}/${sizeData?.name || 'N/A'}`}</p>
              <p style={{ color: isBlack ? '#FFFFFF' : '#000000',fontFamily:'PdfSafe' }} className="pdf-force text-[7pt]">{sizeData?.cn || 'N/A'}</p>
            </div>
            <div className="flex w-full justify-between">
              <p className="font-arialNarrow text-[7pt]">RUC 80089348-4</p>
              <p className="font-arialNarrow text-[7pt]">RN 77302</p>
            </div>
            <div className="flex justify-center">
              <div className="w-[22mm] ml-4">
                <GrupoLogo />
              </div>
            </div>
          </div>
        </div>
      </LabelCard>
      )
    });

    // Label 2 - Company Addresses (korunacak)
    allLabels.push({
      number: 2,
      type: 'back',
      jsx: (
        <LabelCard key="label-2" type="back" number={2}>
         <div className="flex items-center h-full">
        <p className="scale-y-[158.7%] leading-[5.7pt] -tracking-[0.20px] px-[2.5mm]">
            INDITEX,S.A. AV. DIPUTACION ED.INDITEX ARTEIXO A CORUÑA (SPAIN) C.I.F. A-15075062
            TEXMODA S.A.S SIC 900.123.408 TAC ARGENTINA S.A. CUIT:30-69314836-3{' '}
            <span>
              V-
              {data?.country?.code || 'N/A'}
            </span>
            -21 AZKA LOGISTICS LLC, TEXTILES ANKA 22, C.A. - RIF.: J-50434538-5 REG N: 0008962TI-24
            MACROMODA S.A. RUC 1792159105001 INDITEX BRASIL LTDA. CNPJ:02952485000491  ITX CANADA LTD. CA 36685
          </p>
        </div>
        </LabelCard>
      )
    });

    // Page2.jsx sırasına göre devam:
    // 1. Label 3 - Korean/Japanese/Mexican Addresses
    allLabels.push({
      number: 3,
      type: 'front',
      jsx: (
        <LabelCard key="label-3" type="front" number={3}>
            <div className="flex items-center h-full">
          <div className="scale-y-[153%] px-[2.5mm] leading-[4.7pt] text-[4.3pt]">
          <p>아이티엑스코리아유한회사 자라리테일코리아주식회사 서울시 강남구 삼성 동 무역센터 20층 080-479-0880 MA-MAROC: Sté AZZURRO IF:1641920 （株）ITXジャパン (0120-713-777) IMPORTADO POR ZARA MEXICO, S.A. DE C.V. PONIENTE 146 NO. 730 COLONIA INDUSTRIAL VALLEJO ALCALDIA AZCAPOTZALCO, C.P. 02300, CIUDAD DE MEXICO, RFC:ZME920824KM3</p>

          </div>
        </div>
        </LabelCard>
      )
    });

    // 2. Label 4 - Country Translate
    allLabels.push({
      number: 4,
      type: 'back',
      jsx: (
        <LabelCard key="label-4" type="back" number={4}>
         <div className="flex items-center h-full">
          <p className="px-[2.5mm] scale-y-[159%] leading-[4.7pt] text-justify">
            {data.country.translate.map((translate) => translate.translate).join(' - ')}
          </p>
        </div>
        </LabelCard>
      )
    });

    // 3. cards (Page2.jsx sırası)
    if (cards && Array.isArray(cards) && cards.length > 0) {
      cards.forEach((card) => {
        const cardNumber = card.props?.number || (tempCurrentNumber++);
        allLabels.push({
          number: cardNumber,
          type: card.props?.type || (cardNumber % 2 === 0 ? 'back' : 'front'),
          jsx: card
        });
      });
    }

    // 4. additionalPhrases (Page2.jsx sırası)
    additionalPhrases.forEach((translation) => {
      const number = tempCurrentNumber++;
      allLabels.push({
        number: number,
        type: number % 2 === 0 ? 'back' : 'front',
        jsx: (
          <LabelCard key={`additional-${number}`} type={number % 2 === 0 ? 'back' : 'front'} number={number}>
               <div className="flex items-center h-full">
                  <div
                    className={`flex flex-col px-[2.5mm] ${
                      translation.length > 400
                        ? 'text-[4.4pt] leading-[4.4pt]'
                        : 'text-[4.7pt] leading-[4.7pt]'
                    } scale-y-[159%] font-arial text-justify`}
                  >
                    {translation.text}
                  </div>
                </div>
          </LabelCard>
        )
      });
    });

    // 5. washingAdditionalPhrases (Page2.jsx sırası)
    washingAdditionalPhrases.forEach((translation) => {
      const number = tempCurrentNumber++;
      allLabels.push({
        number: number,
        type: number % 2 === 0 ? 'back' : 'front',
        jsx: (
          <LabelCard key={`washing-${number}`} type={number % 2 === 0 ? 'back' : 'front'} number={number}>
            <div className="flex items-center h-full">
                  <div
                    className={`flex flex-col px-[2.5mm] ${
                      translation.text.length > 400
                        ? 'text-[3.8pt] leading-[3.8pt]'
                        : 'text-[5.04pt] leading-[5.05pt]'
                    } scale-y-[159%] tracking-[0.12mm] font-arial text-justify`}
                  >
                    {translation.text}
                  </div>
                </div>
          </LabelCard>
        )
      });
    });

    // 6. isEmptyLabel (Page2.jsx sırası)
    const totalLabelCountBeforeEmpty = allLabels.length;
    const newIsEmptyLabel = (isSymbolTranslate && totalLabelCountBeforeEmpty % 2 === 0) || (!isSymbolTranslate && totalLabelCountBeforeEmpty % 2 === 1);
    if (newIsEmptyLabel) {
      const emptyNumber = tempCurrentNumber++;
      allLabels.push({
        number: emptyNumber,
        type: 'back',
        jsx: <LabelCard key={`empty-${emptyNumber}`} type="back" number={emptyNumber} />
      });
    }

    // Symbols label'ını oluşturma fonksiyonu
    const createSymbolsLabel = (number) => (
      <LabelCard key={`label-symbols-${number}`} type="back" number={number}>
      <div className="flex items-center h-full ">
          <div className="flex items-start justify-between px-[6mm] w-full">
       
            <div className="w-[21.5mm] h-[14mm] grid grid-cols-5 place-items-center items-start gap-y-1">
              {/* Ust sira */}
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${
                  symbol['wash']
                }.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}

              />
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${
                  symbol['bleach']
                }.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}

              />
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${
                  symbol['tumble']
                }.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}

              />
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${
                  symbol['iron']
                }.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}

              />
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${
                  symbol['dry']
                }.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}

              />
              {/* Orta Sira */}
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${
                  symbol['wash']
                }_1.svg`}
                alt="sembol icon"
                style={{width:14,height:14 ,padding:0.4}}

              />
<img
  src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${
    symbol['bleach']
  }_1.svg`}
  alt="sembol icon"
  style={{width:16,height:16 ,padding:0.4}}



/>
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${
                  symbol['iron']
                }_1.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}


              />
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${
                  symbol['dry']
                }_1.svg`}
                alt="sembol icon"
                style={{width:14,height:14 ,padding:0.4}}


              />
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${
                  symbol['tumble']
                }_1.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}


              />

              {/* Alt sira */}
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${
                  symbol['wash']
                }_2.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4,marginTop:1}}

              />
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${
                  symbol['bleach']
                }_2.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}

              />
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${
                  symbol['tumble']
                }_2.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}

              />
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${
                  symbol['iron']
                }_2.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}

              />
              <img
                src={`${BASE_URL2}/images/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${
                  symbol['dry']
                }_2.svg`}
                alt="sembol icon"
                style={{width:16,height:16 ,padding:0.4}}

              />
            </div>
            <div  className={`${isBlackLabel ? 'h-[13.5mm] w-[13.5mm]' : 'h-[14.6mm] w-[14.6mm]'} `}>
              <ZaraQr className={`fill:white bg-white ${isBlackLabel ? 'p-[0.1mm]' : ''}`} />
            </div>
          </div>
        </div>
      </LabelCard>
    );

    // 7. FR Logo (Page2.jsx sırası)
    const frLogoNumber = tempCurrentNumber++;
    allLabels.push({
      number: frLogoNumber,
      type: 'front',
      jsx: (
        <LabelCard key={`label-${frLogoNumber}`} type="front" number={frLogoNumber}>
             <div className="flex items-center h-full ">
          <div className="pl-[13mm] pr-[12mm] pb-[0.5mm] w-full">
            <FrLogo className={`${isBlackLabel ? 'fill-white' : 'fill-[#1d1d1b]'}`} />
          </div>
        </div>
        </LabelCard>
      )
    });

    // 8. Symbols (Page2.jsx sırası) - currentNumber++ (en yüksek number olacak)
    const symbolsNumber = tempCurrentNumber++;
    allLabels.push({
      number: symbolsNumber,
      type: 'back',
      jsx: createSymbolsLabel(symbolsNumber)
    });

    // 9. isSymbolTranslate (Page2.jsx sırası) - currentNumber++
    if (isSymbolTranslate && data.symbolTranslate) {
      const symbolTranslateNumber = tempCurrentNumber++;
      allLabels.push({
        number: symbolTranslateNumber,
        type: 'front',
        jsx: (
          <LabelCard key={`symbol-translate-${symbolTranslateNumber}`} type="front" number={symbolTranslateNumber}>
              <div className="px-[2.5mm] flex flex-col justify-center h-full text-[3.8pt] leading-[4.4pt] scale-y-[1.3]">
            {data.symbolTranslate.map((item) => (
              <div>{item}</div>
            ))}
          </div>
          </LabelCard>
        )
      });
    }

    // En yüksek number'ı bul
    const maxNumber = Math.max(...allLabels.map(l => l.number));

    // Number'a göre sırala
    allLabels.sort((a, b) => a.number - b.number);

    // Yerleşim mantığına göre düzenle: küçük-büyük, büyük-küçük, küçük-büyük, büyük-küçük...
    // 1,12 | 11,2 | 3,10 | 9,4 | 5,8 | 7,6 şeklinde
    const arrangedLabels = [];
    const used = new Set();

    // Alternatif sıralama: i tek ise (küçük, büyük), i çift ise (büyük, küçük)
    for (let i = 1; i <= Math.floor(maxNumber / 2); i++) {
      const pairNumber = maxNumber - (i - 1);
      
      if (i % 2 === 1) {
        // Tek sayılar: küçük-büyük (1,12 | 3,10 | 5,8) - ilk sol, ikinci sağ
        const label1 = allLabels.find(l => l.number === i && !used.has(l.number));
        const label2 = allLabels.find(l => l.number === pairNumber && !used.has(l.number));
        
        if (label1) {
          // İlk label sol
          arrangedLabels.push({ ...label1, orientation: 'Left' });
          used.add(label1.number);
        }
        if (label2) {
          // İkinci label sağ
          arrangedLabels.push({ ...label2, orientation: 'Right' });
          used.add(label2.number);
        }
      } else {
        // Çift sayılar: büyük-küçük (11,2 | 9,4 | 7,6) - ilk sol, ikinci sağ
        const label1 = allLabels.find(l => l.number === pairNumber && !used.has(l.number));
        const label2 = allLabels.find(l => l.number === i && !used.has(l.number));
        
        if (label1) {
          // İlk label sol
          arrangedLabels.push({ ...label1, orientation: 'Left' });
          used.add(label1.number);
        }
        if (label2) {
          // İkinci label sağ
          arrangedLabels.push({ ...label2, orientation: 'Right' });
          used.add(label2.number);
        }
      }
    }

    // Ortadaki tek kalan label'ı ekle (eğer tek sayıda varsa)
    if (maxNumber % 2 === 1) {
      const middleNumber = Math.ceil(maxNumber / 2);
      const middleLabel = allLabels.find(l => l.number === middleNumber && !used.has(l.number));
      if (middleLabel) {
        // Ortadaki label sol (varsayılan)
        arrangedLabels.push({ ...middleLabel, orientation: 'Left' });
        used.add(middleLabel.number);
      }
    }

    // Kalan label'ları ekle (eğer varsa - bu normalde olmamalı ama güvenlik için)
    allLabels.forEach(label => {
      if (!used.has(label.number)) {
        // Kalan label'lar için varsayılan olarak sol
        arrangedLabels.push({ ...label, orientation: 'Left' });
      }
    });

    setOrderedLabels(arrangedLabels);
    setIsEmptyLabel(newIsEmptyLabel);
    setIsSymbolTranslate(!!data.symbolTranslate);
  }, [data, sizeData, selectColor, barcodeValue, isBlack, isBlackLabel, lastNumber, isSymbolTranslate, cards, additionalPhrases, washingAdditionalPhrases]);

  return (
    <div style={{width:600}} className="flex flex-wrap gap-y-3" ref={ref}>
      {orderedLabels.map((label) => {
        // LabelCard'a orientation prop'unu ekle
        return React.cloneElement(label.jsx, { orientation: label.orientation });
      })}
    </div>
  )
}

export default memo(Page2Book)
